/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NullableMoneyOutput } from './NullableMoneyOutput';
import {
    NullableMoneyOutputFromJSON,
    NullableMoneyOutputFromJSONTyped,
    NullableMoneyOutputToJSON,
    NullableMoneyOutputToJSONTyped,
} from './NullableMoneyOutput';

/**
 * 
 * @export
 * @interface ShippingData
 */
export interface ShippingData {
    /**
     * 
     * @type {string}
     * @memberof ShippingData
     */
    remoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingData
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingData
     */
    amount?: number;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof ShippingData
     */
    chargedPrice?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof ShippingData
     */
    completedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingData
     */
    receivedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ShippingData
     */
    cancelledAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingData
     */
    chargeComplete?: boolean;
}

/**
 * Check if a given object implements the ShippingData interface.
 */
export function instanceOfShippingData(value: object): value is ShippingData {
    return true;
}

export function ShippingDataFromJSON(json: any): ShippingData {
    return ShippingDataFromJSONTyped(json, false);
}

export function ShippingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShippingData {
    if (json == null) {
        return json;
    }
    return {
        
        'remoteId': json['remoteId'] == null ? undefined : json['remoteId'],
        'name': json['name'] == null ? undefined : json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'chargedPrice': json['chargedPrice'] === undefined ? undefined : json['chargedPrice'] === null ? null : NullableMoneyOutputFromJSON(json['chargedPrice']),
        'completedAmount': json['completedAmount'] == null ? undefined : json['completedAmount'],
        'receivedAmount': json['receivedAmount'] == null ? undefined : json['receivedAmount'],
        'cancelledAmount': json['cancelledAmount'] == null ? undefined : json['cancelledAmount'],
        'chargeComplete': json['chargeComplete'] == null ? undefined : json['chargeComplete'],
    };
}

export function ShippingDataToJSON(json: any): ShippingData {
    return ShippingDataToJSONTyped(json, false);
}

export function ShippingDataToJSONTyped(value?: ShippingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remoteId': value['remoteId'],
        'name': value['name'],
        'amount': value['amount'],
        'chargedPrice': NullableMoneyOutputToJSON(value['chargedPrice']),
        'completedAmount': value['completedAmount'],
        'receivedAmount': value['receivedAmount'],
        'cancelledAmount': value['cancelledAmount'],
        'chargeComplete': value['chargeComplete'],
    };
}

